const de = {
  placeholderText: "Eingabe",
  closeContentText: "Aktuellen Dialog beenden?",
  cancelText: "Abbrechen",
  okText: "OK",
  loadingAnswerQuestions:
    "Bearbeite Ihre vorherige Frage. Bitte später absenden.",
  networkAnomalyText: "Netzwerkstörung. Bitte später erneut versuchen.",
  errorText: "Serverfehler",
  messageTooShort: "Es müssen mindestens zwei Zeichen eingegeben werden.",
  messageTooLong: "Darf nicht mehr als 200 Zeichen enthalten.",
  systemErrorText: "Systemfehler. Bitte versuchen Sie es später erneut.​​",
  fileSizeExceeded: "Einzelne Dateien dürfen {maxSize}MB nicht überschreiten.",
  abnormalDisconnectionText: "Verbindung unterbrochen. Stelle neu her...",
  evaluationText: "Ihr Feedback macht uns besser!",
  emailLabel: "​​E-Mail​​",
  emailPlaceholder: "Ihre E-Mail-Adresse eingeben",
  emailErrorText: "Ungültiges E-Mail-Format.",
  productLabel: "Produkt",
  productPlaceholder: "Produkt auswählen",
  problemLabel: "Problembeschreibung",
  problemPlaceholder: "Beschreiben Sie das Problem im Detail",
  submitText: "Absenden",
  submitField: "Übertragung fehlgeschlagen. Bitte später erneut versuchen.",
  thankText:
    "Vielen Dank für Ihre Zusammenarbeit! Wir werden Sie schnellstmöglich kontaktieren! Bitte überprüfen Sie Ihre E-Mails oder {link}, um Nachrichten zu verfolgen!",
  clickHere: "klicken Sie hier​",
  thankEvaluation: "​​Danke für Ihre Bewertung!",
  codeLabel: "Bestätigungscode",
  codePlaceholder: "Bitte geben Sie den Bestätigungscode ein",
  submittedSuccessfully: "Erfolgreich übermittelt",
  supportContact: "Support-Kontakt",
  stillCancel: "Trotzdem abbrechen",
  useDiscount: "Rabatt anwenden",
  pauseDuration: "Pausendauer",
  uploadAttachment: "Anhang hochladen",
};
export default de;
